document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('#testimonial-carousel [data-index]');
  const thumbnails = document.querySelectorAll('.thumbnail-container [data-index]');
  const prevBtn = document.getElementById('prev-btn');
  const nextBtn = document.getElementById('next-btn');
  const mainImage = document.getElementById('main-image');
  const paginationDots = document.getElementById('pagination-dots');
  let activeIndex = 0;
  let autoRotateInterval;

  // Create Pagination Dots
  items.forEach((item, index) => {
    const dot = document.createElement('div');
    dot.className = 'pagination-dot tw-cursor-pointer';
    if (index === activeIndex) dot.classList.add('tw-bg-black');
    dot.dataset.index = index;
    paginationDots.appendChild(dot);

    // Add click event for each dot
    dot.addEventListener('click', () => {
      showItem(index);
      restartAutoRotate(); // Restart the auto-rotation on manual interaction
    });
  });

  function showItem(index) {
    // Show the active item
    items.forEach((item, i) => {
      item.classList.toggle('tw-hidden', i !== index);
    });

    // Update Main Image
    const thumbnail = thumbnails[index]?.querySelector('img');
    if (thumbnail) {
      mainImage.src = thumbnail.src.replace('200x200', '800x800');
    }

    // Update Active Dot
    const dots = paginationDots.querySelectorAll('.pagination-dot');
    dots.forEach((dot, i) => {
      dot.classList.toggle('tw-bg-black', i === index);
      dot.classList.toggle('tw-bg-gray-400', i !== index);
    });

    // Update Active Thumbnail
    thumbnails.forEach((thumbnail, i) => {
      thumbnail.classList.toggle('active', i === index);
      thumbnail.classList.toggle('inactive', i !== index);
    });

    activeIndex = index;
  }

  // Handle Previous Button
  prevBtn.addEventListener('click', () => {
    const newIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    showItem(newIndex);
    restartAutoRotate(); // Restart the auto-rotation on manual interaction
  });

  // Handle Next Button
  nextBtn.addEventListener('click', () => {
    const newIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    showItem(newIndex);
    restartAutoRotate(); // Restart the auto-rotation on manual interaction
  });

  // Handle Thumbnail Click
  thumbnails.forEach((thumbnail, index) => {
    thumbnail.addEventListener('click', () => {
      showItem(index);
      restartAutoRotate(); // Restart the auto-rotation on manual interaction
    });
  });

  // Auto-Rotate Functionality
  function startAutoRotate() {
    autoRotateInterval = setInterval(() => {
      const newIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
      showItem(newIndex);
    }, 5000); // Change item every 5 seconds
  }

  function stopAutoRotate() {
    clearInterval(autoRotateInterval);
  }

  function restartAutoRotate() {
    stopAutoRotate();
    startAutoRotate();
  }

  // Initialize (Set first thumbnail as active by default)
  showItem(activeIndex);

  // Start auto-rotation
  startAutoRotate();

  // Pause auto-rotation on mouse hover and resume on mouse leave
  const carousel = document.getElementById('testimonial-carousel');
  carousel.addEventListener('mouseenter', stopAutoRotate);
  carousel.addEventListener('mouseleave', startAutoRotate);
});